export enum ChartType {
  Price = "price",
  Holdings = "holdings",
}
